// extracted by mini-css-extract-plugin
export default {"hidden":"HeadingBuilder_hidden__ngNDB"};